import React, { useState, Fragment, useLayoutEffect, useRef } from "react"
import { useTranslation } from "react-i18next"
import { toast } from "react-toastify"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useHistory } from "react-router-dom"
import clsx from "clsx"

import { createPrintRequest, moment } from "utils"
import { tableStatusColors } from "constant"
import { setOrderTableNumber } from "@redux"
import { editOrderTableNumber } from "services"
import { ConfirmationModal, } from "components"
import classes from "./KtBox.module.scss"

const tableSizes = {
  small: 25,
  medium: 35,
  large: 45
}

const KtBox = props => {
  const {
    table,
    setTableOrders,
    selectedOrders,
    setSelectedOrders,
    setSelectedTableId,
    showMoveTableMessage,
    setShowMoveTableMessage,
    setOpenTableSidebar
  } = props

  const [t, i18n] = useTranslation()

  const location = useLocation()

  const dispatch = useDispatch()

  const history = useHistory()

  const printers =
    useSelector(state => state.printers)

  const [sending, setSending] = useState(false)
  const [boxPosition, setBoxPosition] = useState({ x: 0, y: 0 })
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  const unmount = useRef(false)

  const print = async () => {
    const orderIds = Object.keys(selectedOrders)

    const movedOrderCodes =
      orderIds.map(orderId =>
        selectedOrders[orderId].code
      )

    const originTableNumber =
      selectedOrders[orderIds[0]].tableNumber

    const printData = {
      date: moment().toISOString(),
      movedOrderCodes,
      originTableNumber: originTableNumber,
      destinationTableNumber: table.tableNumber
    }

    await Promise.all(
      printers.map(
        async (printerSettings, printerIndex) => {
          const request = {
            printType: "tableMoved",
            printerIndex,
            printData,
            printerSettings,
            saveToFailedPrints: true
          }

          try {
            createPrintRequest(request)
          } catch (err) {
            console.log(err)
          }
        }
      )
    )
  }

  const handlePress = () => {
    if (location.state.previousPage === "/checkout") {
      dispatch(
        setOrderTableNumber(
          table.tableNumber
        )
      )

      history.push(
        "/checkout",
        {
          mode: location.state?.mode,
          previousChechkoutStates: location.state?.previousChechkoutStates
        }
      )

      return
    }

    if (showMoveTableMessage) {
      setShowConfirmationModal(true)

      return
    }

    setSelectedTableId(table._id)

    setOpenTableSidebar(true)
  }

  const handleTableOrdersMove = async () => {
    setSending(true)

    const orderIds = Object.keys(selectedOrders)

    try {
      for (const orderId of orderIds) {
        await editOrderTableNumber(
          orderId,
          table.tableNumber
        )
      }

      print()

      setTableOrders(prev =>
        prev.filter(to => !selectedOrders[to._id])
      )

      setSelectedOrders({})

      setShowMoveTableMessage(false)

      setShowConfirmationModal(false)
    } catch (err) {
      console.log(err)

      toast.error(t("جابه_جایی_میز_انجام_نشد"))
    }

    setSending(false)
  }

  const initialTablePosition = () => {
    if (unmount.current) return

    const containerWidth =
      document.getElementById("tables-container").offsetWidth

    const containerHeight =
      document.getElementById("tables-container").offsetHeight

    setBoxPosition({
      x: -(table.position.x * containerWidth) | 0,
      y: (table.position.y * containerHeight) | 0
    })
  }

  useLayoutEffect(() => {
    unmount.current = false

    initialTablePosition()

    return () => unmount.current = true
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <button
        onClick={handlePress}
        className={clsx(
          classes["box"],
          isLtr && classes["box-ltr"],
          classes[table.shape]
        )}
        style={{
          width: tableSizes[table.scale],
          height: tableSizes[table.scale],
          borderColor: `var(--color-${[tableStatusColors[table.status]]})`,
          right: isLtr ? "unset" : `${boxPosition.x}px`,
          left: isLtr ? `${boxPosition.x}px` : "unset",
          top: `${boxPosition.y}px`,
          transform:
            table.shape === "diamond" ? "rotate(45deg)" : ""
        }}
      >
        <span
          className={classes["text"]}
          style={{
            transform:
              table.shape === "diamond" ? "rotate(-45deg)" : ""
          }}
        >
          {table.tableNumber}
        </span>
      </button>

      <ConfirmationModal
        title={t("آیا_می_خواهید_میز_tableNumber_را_حذف_کنین", { tableNumber: table.tableNumber })}
        show={showConfirmationModal}
        onConfirm={handleTableOrdersMove}
        onHide={() => setShowConfirmationModal(false)}
        loading={sending}
      />
    </Fragment>
  )
}

export default React.memo(KtBox)